import Step2Action from './step2-action';
import Step3Action from './step3-action';

/**
 * Initializes all actions for the vendor registration.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class VendorRegistration {
    constructor(containers: NodeListOf<HTMLElement>) {
        containers.forEach(container => {
            let actionContainer = container.querySelector<HTMLElement>('[data-action="step2"]');
            if (actionContainer) {
                new Step2Action(actionContainer);
                return;
            }

            actionContainer = container.querySelector<HTMLElement>('[data-action="step3"]');
            if (actionContainer) {
                new Step3Action(actionContainer);
                return;
            }
        });
    }
}
